
import SessionService from './SessionService';

export default class RoutesService {

    // Get all routes from local storage
    static getRoutes() {
        const data = SessionService.getData();
        if (data) { return data.routes; }
        return [];
    }

    // Return array names by route path
    static getRouterArray(routePath) {
        const route = routePath.split('/').slice(1, 4);
        return route;
    }

    // verifica se o usuário possui permissão de acesso a rota
    static hasPermission(value) {
        const data = SessionService.getData();

        // Função recursiva para buscar o valor em routes, path ou routeName
        const searchValue = (routes, targetValue) => {
            for (const route of routes) {
                // Verifica se o valor corresponde ao path ou routeName
                if (route.path === targetValue || route.routeName === targetValue) {
                    return true;
                }

                // Verifica nas áreas (se existirem)
                if (route.areas) {
                    for (const area of route.areas) {
                        // Verifica nas opções dentro da área
                        if (area.options) {
                            const found = area.options.some(
                                option =>
                                    option.path === targetValue || option.routeName === targetValue
                            );
                            if (found) {
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        };

        // Chama a função de busca
        return searchValue(data.routes, value);
    }



    // Return module name by route path
    static getModuleNameOrRoute(routePath, route = false) {
        const data = SessionService.getData();
        let arrayRoutePath = this.getRouterArray(routePath);

        for (let i = 0; i < data.routes.length; i++) {
            if (data.routes[i].path.includes(arrayRoutePath[0])) {
                if (route) {
                    return data.routes[i];
                }
                else {
                    return data.routes[i].name;
                }
            }
        }
    }


    // Return module name by route path
    static getOptionArrayOrRoute(routePath, route = false) {

        const optionPath = routePath.split('/').slice(2, 3);
        const module = this.getModuleNameOrRoute(routePath, true);
        const areas = module.areas;
        let arrayRoute = []

        const moduleObj = { "name": module.name, "path": module.path };
        arrayRoute.push(moduleObj);

        for (let i = 0; i < areas.length; i++) {
            const area = areas[i];

            const areaObj = { "name": area.name };
            arrayRoute.push(areaObj);

            for (let j = 0; j < area.options.length; j++) {
                const option = area.options[j];
                if (option.path.includes(optionPath)) {
                    if (route) {
                        return option;
                    }
                    else {
                        const optionObj = { "name": option.name, "path": option.path };
                        arrayRoute.push(optionObj)
                        return arrayRoute;
                    }
                }
            }

        }
    }

    static getRouteAreas(routePath) {
        const rootPath = routePath.split('/')[1];
        const routes = this.getRoutes();

        for (let i = 0; i < routes.length; i++) {
            const route = routes[i];
            if (route.path.includes(rootPath)) {
                return route.areas;
            }
        }
    }

    static contains(routePath) {
        const route = $this.route.path;
        if (route.includes(routePath)) {
            return true;
        }
        return false;
    }


}